const dictionaryConfig = {
    'common': {
        'contact': {
            'hu-HU': 'Kapcsolat',
            'en-GB': 'Contact'
        },
        'brands': {
            'hu-HU': 'Creo',
            'en-GB': 'Brands'
        },
        'language': {
            'hu-HU': 'Nyelvek',
            'en-GB': 'Languages'
        },
        'email-address': {
            'hu-HU': 'E-mail cím',
            'en-GB': 'E-mail address'
        },
        'phone-number': {
            'hu-HU': 'Telefonszám',
            'en-GB': 'Phone number'
        }
    },
    'www': {
        'hero-title': {
            'hu-HU': 'Kik vagyunk?',
            'en-GB': 'Who are we?'
        },
        'hero-content': {
            'hu-HU': 'A Creo Group szoft&shy;ver&shy;fej&shy;lesz&shy;tő cég. Erős mes&shy;ter&shy;sé&shy;ges in&shy;tel&shy;li&shy;gen&shy;ci&shy;a kom&shy;pe&shy;ten&shy;ci&shy;á&shy;val ren&shy;del&shy;ke&shy;zünk. Szá&shy;mos in&shy;no&shy;va&shy;tív szoft&shy;ver&shy;meg&shy;ol&shy;dás&shy;unk van az ipar szá&shy;má&shy;ra. A&shy;lap&shy;ve&shy;tő&shy;en üz&shy;le&shy;ti szoft&shy;ve&shy;rek fej&shy;lesz&shy;té&shy;sé&shy;vel fog&shy;lal&shy;ko&shy;zunk, szá&shy;mos nagy név&shy;vel a meg&shy;ren&shy;de&shy;lői port&shy;fó&shy;li&shy;ónk&shy;ban. Nagy gya&shy;kor&shy;la&shy;tunk van kom&shy;plex üz&shy;le&shy;ti fo&shy;lya&shy;ma&shy;tok di&shy;gi&shy;ta&shy;li&shy;zá&shy;lá&shy;sá&shy;ban és egy&shy;sze&shy;rű&shy;sí&shy;té&shy;sé&shy;ben. Szin&shy;tén ajánl&shy;juk web&shy;fej&shy;lesz&shy;tő szol&shy;gál&shy;ta&shy;tá&shy;sunkat, a&shy;mely&shy;nek ke&shy;re&shy;té&shy;ben ma&shy;gas mi&shy;nő&shy;sé&shy;gű rend&shy;sze&shy;re&shy;ket ké&shy;szí&shy;tünk. A mo&shy;bil fej&shy;lesz&shy;tés ma már el&shy;en&shy;ged&shy;he&shy;tet&shy;len. An&shy;droid és iOS kör&shy;nye&shy;zet&shy;ben van ta&shy;pasz&shy;ta&shy;la&shy;tunk.',
            'en-GB': 'Creo Group is a soft&shy;ware de&shy;vel&shy;op&shy;er com&shy;pa&shy;ny with a strong com&shy;pe&shy;tence in ma&shy;chine learn&shy;ing. We pro&shy;vide sev&shy;er&shy;al in&shy;no&shy;va&shy;tive soft&shy;ware so&shy;lu&shy;tions for the in&shy;dus&shy;try. We have our roots in busi&shy;ness soft&shy;ware de&shy;vel&shy;op&shy;ment with big names in our port&shy;fo&shy;lio. Re&shy;gard&shy;ing soft&shy;ware de&shy;vel&shy;op&shy;ment, we are trained to cov&shy;er com&shy;plex busi&shy;ness work&shy;flows and are des&shy;ig&shy;nat&shy;ed to sim&shy;pli&shy;fy them. We also of&shy;fer our web de&shy;vel&shy;op&shy;ment ser&shy;vic&shy;es to de&shy;liv&shy;er fan&shy;cy and high qual&shy;i&shy;ty brows&shy;er based sys&shy;tems. App de&shy;vel&shy;op&shy;ment is a must have, we cov&shy;er the main mo&shy;bile plat&shy;forms.'
        },
        'slider-title': {
            'hu-HU': 'Miben vagyunk nagyon jók?',
            'en-GB': 'What are we very good at?'
        },
        'slider-sub-title': {
            'hu-HU': 'Találd meg a neked megfelelő szolgáltatást! Kombinálhatod is őket! 😉',
            'en-GB': 'Find a service that fits your needs. You can also combine them! 😉'
        },
        'client-title': {
            'hu-HU': 'Ügyfeleink',
            'en-GB': 'Our clients'
        },
        'client-sub-title': {
            'hu-HU': 'Akikre nagyon büszkék vagyunk',
            'en-GB': 'We are very proud at'
        },
        'contact-title': {
            'hu-HU': 'Írj nekünk!',
            'en-GB': 'Say Hello!'
        },
        'contact-content-pre': {
            'hu-HU': 'Írj nekünk az',
            'en-GB': 'Write to'
        },
        'contact-content-post': {
            'hu-HU': 'címre, vagy hívj minket:',
            'en-GB': 'or call'
        }
    }
}

export default dictionaryConfig;